<template lang="pug">
b-modal#addMiniGame(
  ref="addMiniGame"
  :title="$t('ui.combine.add_mini_game')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.game_type')").mb-1
      b-form-select(
        ref="game_type"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.game_type.$dirty"
        :error="$v.game_type.$error"
        :class="{ 'is-invalid': $v.game_type.$dirty && $v.game_type.$error, 'is-valid': $v.game_type.$dirty && !$v.game_type.$error }"
        v-model.trim.lazy="$v.game_type.$model"
        )
        option(value="" disabled selected) {{ $t("message.select_option") }}
        option(v-for="item in gameTypeList" :value="item") {{ item.toUpperCase() }}
      ValidateResult(:value="$v.game_type" :name="$t('ui.game_type')")
    b-form-group(:label="$t('ui.game_name')").mb-1
      DebounceInput(
        size="sm"
        ref="game_name"
        required
        type="text"
        :dirty="$v.game_name.$dirty"
        :error="$v.game_name.$error"
        v-model.trim.lazy="$v.game_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.game_name" :name="$t('ui.game_name')")
    b-form-group(:label="$t('ui.token_request')").mb-1
      DebounceInput(
        size="sm"
        ref="token_request"
        required
        type="number"
        :dirty="$v.token_request.$dirty"
        :error="$v.token_request.$error"
        v-model.trim.lazy="$v.token_request.$model"
        :disabled="loading"
        keyPressRestrict="restrictOnlyNumber"
      )
      ValidateResult(:value="$v.token_request" :name="$t('ui.token_request')" :fvalue="'0'")
    b-form-group(:label="$t('ui.max_game_reward')").mb-1
      DebounceInput(
        size="sm"
        ref="max_game_reward"
        required
        type="number"
        :dirty="$v.max_game_reward.$dirty"
        :error="$v.max_game_reward.$error"
        v-model.trim.lazy="$v.max_game_reward.$model"
        :disabled="loading"
        keyPressRestrict="restrictOnlyNumber"
      )
      ValidateResult(:value="$v.max_game_reward" :name="$t('ui.max_game_reward')" :fvalue="'0'")
    b-form-group(:label="$t('ui.max_chance_unlimited')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="max_chance_unlimited")
        span.custom-switch-indicator
    b-form-group(:label="$t('ui.max_chance_per_day')" :disabled="max_chance_unlimited").mb-1
      DebounceInput(
        size="sm"
        ref="max_chance_per_day"
        required
        type="number"
        :dirty="$v.max_chance_per_day.$dirty"
        :error="$v.max_chance_per_day.$error"
        v-model.trim.lazy="$v.max_chance_per_day.$model"
        :disabled="loading"
        keyPressRestrict="restrictOnlyNumber"
      )
      ValidateResult(:value="$v.max_chance_per_day" :name="$t('ui.max_chance_per_day')" :fvalue="'0'")
    b-form-group(:label="$t('ui.is_recurring_chance')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="is_recurring_chance")
        span.custom-switch-indicator
    b-form-group(:label="$t('ui.status')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="is_enable")
        span.custom-switch-indicator
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      game_type: '',
      game_name: '',
      is_enable: true,
      is_recurring_chance: false,
      gameTypeList: config.miniGameType,
      token_request: 1,
      max_game_reward: 1,
      max_chance_unlimited: false,
      max_chance_per_day: 1
    };
  },
  validations: {
    game_type: {
      required
    },
    game_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(150)
    },
    token_request: {
      required,
      mustMoreThan: function(value) {
        if(parseFloat(value) <= 0) return false
        return true
      }
    },
    max_game_reward: {
      required,
      mustMoreThan: function(value) {
        if(parseFloat(value) <= 0) return false
        return true
      }
    },
    max_chance_per_day: {
      required,
      mustMoreThan: function(value) {
        if(this.max_chance_unlimited) return true
        if(parseFloat(value) <= 0) return false
        return true
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addMiniGameUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          game_type: this.game_type,
          game_name: this.game_name,
          max_game_reward: this.max_game_reward,
          is_recurring_chance: this.is_recurring_chance,
          token_request: this.token_request,
          enable: this.is_enable
        };

        if(this.max_chance_unlimited) json.max_chance_per_day = null
        else json.max_chance_per_day = this.max_chance_per_day

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_mini_game", this.feedback.status);
              }
              this.$nextTick(() => {
                this.$refs.addMiniGame.hide();
              });
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
              this.$nextTick(() => {
                this.$refs.addMiniGame.hide();
              });
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
      }
    },
    reset() {
      this.game_type = "";
      this.game_name = "";
      this.is_enable = true;
      this.is_recurring_chance = false;
      this.token_request = 1;
      this.max_game_reward = 1;
      this.max_chance_unlimited = false;
      this.max_chance_per_day = 1;
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.$refs.game_type.$el.focus();
    }
  }
};
</script>
